/**
 * User Recommend API (V1)
 * Server: GET/POST/DELETE /api/v1/users/{user_id}/recommends
 */

import { ApiBase } from "../../core/api-base";
import { z } from "zod";
import { UpsertUserRecommendBody } from "../../api/generated/users.zod";

type UpsertUserRecommendPayload = z.infer<typeof UpsertUserRecommendBody>;

export class UserRecommendApi extends ApiBase {
    public static async getMeta(userId: number): Promise<Response> {
        return await super.apiGet(`/api/v1/users/recommends/${userId}`, { noSpinner: true });
    }

    public static async upsert(userId: number, rank: number | null): Promise<Response> {
        const payload: UpsertUserRecommendPayload = { rank: rank === null ? null : Number(rank) };
        return await super.apiPost(`/api/v1/users/recommends/${userId}`, payload, { noSpinner: true });
    }

    public static async remove(userId: number): Promise<Response> {
        return await super.apiDelete(`/api/v1/users/recommends/${userId}`, { noSpinner: true });
    }
}
